import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QosApiService {

  constructor(private http: HttpClient) {
  }

  readonly qosUrl: string = 'configuration/diffServ';

  public getQosSettings(): Observable<any> {
    return this.http.get(this.qosUrl);
  }

  public editQosSettings(qosSettings): Observable<any> {
    return this.http.put(this.qosUrl, qosSettings);
  }
}
